/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrafficHeaders,
    TrafficHeadersFromJSON,
    TrafficHeadersFromJSONTyped,
    TrafficHeadersToJSON,
} from './TrafficHeaders';

/**
 * 
 * @export
 * @interface TrafficSource
 */
export interface TrafficSource {
    /**
     * Identifies a specific campaign.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_id?: string;
    /**
     * Identifies the source of the link, such as twitter or direct.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_source: string;
    /**
     * Identifies the medium used to access the link, such as email or referral.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_medium: string;
    /**
     * Identifies the name of a product promotion or campaign.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_campaign?: string;
    /**
     * Identifies keywords for the link (for paid purchases).
     * @type {string}
     * @memberof TrafficSource
     */
    utm_term?: string;
    /**
     * Used to differ between content pointing to the same url, such as image, menu, or sidebar.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_content?: string;
    /**
     * Identifies which budget is used for the campaign promotion.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_budget?: string;
    /**
     * Identifies which audience is used for the campaign promotion.
     * @type {string}
     * @memberof TrafficSource
     */
    utm_audience?: string;
    /**
     * Identifies the Facebook click ID.
     * @type {string}
     * @memberof TrafficSource
     */
    fbclid?: string;
    /**
     * Identifies the Google Ads source.
     * @type {string}
     * @memberof TrafficSource
     */
    gad_source?: string;
    /**
     * Identifies the Google click ID.
     * @type {string}
     * @memberof TrafficSource
     */
    gclid?: string;
    /**
     * 
     * @type {TrafficHeaders}
     * @memberof TrafficSource
     */
    headers?: TrafficHeaders;
}

export function TrafficSourceFromJSON(json: any): TrafficSource {
    return TrafficSourceFromJSONTyped(json, false);
}

export function TrafficSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrafficSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'utm_id': !exists(json, 'utm_id') ? undefined : json['utm_id'],
        'utm_source': json['utm_source'],
        'utm_medium': json['utm_medium'],
        'utm_campaign': !exists(json, 'utm_campaign') ? undefined : json['utm_campaign'],
        'utm_term': !exists(json, 'utm_term') ? undefined : json['utm_term'],
        'utm_content': !exists(json, 'utm_content') ? undefined : json['utm_content'],
        'utm_budget': !exists(json, 'utm_budget') ? undefined : json['utm_budget'],
        'utm_audience': !exists(json, 'utm_audience') ? undefined : json['utm_audience'],
        'fbclid': !exists(json, 'fbclid') ? undefined : json['fbclid'],
        'gad_source': !exists(json, 'gad_source') ? undefined : json['gad_source'],
        'gclid': !exists(json, 'gclid') ? undefined : json['gclid'],
        'headers': !exists(json, 'headers') ? undefined : TrafficHeadersFromJSON(json['headers']),
    };
}

export function TrafficSourceToJSON(value?: TrafficSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'utm_id': value.utm_id,
        'utm_source': value.utm_source,
        'utm_medium': value.utm_medium,
        'utm_campaign': value.utm_campaign,
        'utm_term': value.utm_term,
        'utm_content': value.utm_content,
        'utm_budget': value.utm_budget,
        'utm_audience': value.utm_audience,
        'fbclid': value.fbclid,
        'gad_source': value.gad_source,
        'gclid': value.gclid,
        'headers': TrafficHeadersToJSON(value.headers),
    };
}

